import script from "./MenuNoticiasView.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuNoticiasView.vue?vue&type=script&setup=true&lang=js"

import "./MenuNoticiasView.vue?vue&type=style&index=0&id=7ae60b72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ae60b72"]])

export default __exports__